/**
 * Stroke width shared by all status icons, in the 16-unit viewBox.
 * Chosen to visually match lucide icons (1.5 in their 24-unit viewBox = 1.0 here),
 * nudged slightly heavier so the small status glyphs hold weight next to outline icons.
 */
export const STATUS_ICON_STROKE_WIDTH = 1.1;
